// Course Outcome – Variant 2 (image cards with "Avg Salary" pill)

export const COURSE_OUTCOME_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: 1,
    meta_image: "",
    meta_image_alt: "",
    meta_mobile_image: "",
    meta_title: "Wealth Manager / Private Banker",
    meta_title_color: "#FFFFFF",
    meta_description:
      "Advise high-net-worth clients on investments, retirement, tax, and estate planning.",
    meta_description_color: "#FFFFFF99",
    meta_box_color: "rgba(0,0,0,0.2)",
    meta_box_title: "20-30 LPA",
    meta_box_title_color: "#FFFFFF",
    meta_box_sub_title: "Avg Salary",
    meta_box_sub_title_color: "#FFFFFF99",
    priority: 1,
    meta_status: true,
  },

  METADATA_TITLES: {
    metadata: "Cards (min 3, max 9)",
  },

  // Min 3 / Max 9 cards arranged as a 3×3 grid (PRD). Enforced in the admin:
  // "Add New Row" caps at 9 and Save is blocked outside the range.
  METADATA_LIMITS: {
    metadata: { min: 3, max: 9 },
  },

  COURSE_OUTCOME_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Where This Program Can Take You",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Heading (e.g., Where This Program Can Take You)",
      required: true,
      defaultValue: "Where This Program Can Take You",
    },
    {
      fieldName: "pre_title_text_color",
      label: "Heading Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter heading color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "description",
      label: "Sub Heading",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Sub Heading",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Sub Heading Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub heading color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "load_more_button",
      label: "View More Button Text",
      value: "View More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter View More button text",
      required: false,
      defaultValue: "View More",
    },
    {
      fieldName: "load_more_button_text_color",
      label: "View More Button Text Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter View More button text color",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Course Outcome Section",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Card Image (gradient must be baked into the image)",
      required: true,
    },
    {
      header: "Card Image Alt Text",
      fieldName: "meta_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for card image",
    },
    {
      header: "Mobile Image",
      fieldName: "meta_mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Image (optional)",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Career Title (e.g., Wealth Manager / Private Banker)",
      required: false,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #FFFFFF)",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Career Description",
    },
    {
      header: "Description Color",
      fieldName: "meta_description_color",
      value: "#FFFFFF99",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #FFFFFF99)",
    },
    {
      header: "Pill Background Color",
      fieldName: "meta_box_color",
      value: "rgba(0,0,0,0.2)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pill background color (e.g., rgba(0,0,0,0.2))",
    },
    {
      header: "Salary Value",
      fieldName: "meta_box_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Salary Value, 1 line (e.g., 20-30 LPA)",
    },
    {
      header: "Salary Value Color",
      fieldName: "meta_box_title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter salary value color (e.g., #FFFFFF)",
    },
    {
      header: "Salary Label",
      fieldName: "meta_box_sub_title",
      value: "Avg Salary",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Salary Label, 1 line (e.g., Avg Salary)",
    },
    {
      header: "Salary Label Color",
      fieldName: "meta_box_sub_title_color",
      value: "#FFFFFF99",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter salary label color (e.g., #FFFFFF99)",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this card",
      defaultValue: true,
    },
  ],
};
